import React from 'react';
import { useNavigate } from 'react-router-dom';
import DigitalDisplay from '../components/DigitalDisplay';
import './Characters.css';

const Characters = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <DigitalDisplay>
        <div className="characters-header">
          <h1>Characters</h1>
        </div>
        <div className="characters-content">
          <p>
            The $1 Odyssey Characters will be revealed soon! Stay tuned for their exciting stories
            and unique abilities as part of our gamified ecosystem.
          </p>
          <p className="coming-soon">
            <strong>Coming Soon - Q1 2025</strong>
          </p>
        </div>
        <div className="choice-button-container">
          <button className="choice-button" onClick={() => navigate('/roadmap')}>
            Back to Roadmap
          </button>
          <button className="choice-button" onClick={() => navigate('/storyline')}>
            Forward to Storyline
          </button>
        </div>
      </DigitalDisplay>
    </div>
  );
};

export default Characters;
